/* eslint-disable */
export const FIELD = {
  AUTH: {
    BUTTON: "AuthButton",
    CARD: "AuthCard"
  },
  INPUT: {
    TEXT: "FieldText",
    TEXTCONFIRMATION: "FieldTextConfirmation",
    TEXTAREA: "FieldTextarea",
    RESPONSE: "FieldResponse",
    ADDRESS: "Field",
    DATE: "Date",
    DATEMEDICARE: "DateMedicare",
    NUMBER: "Number",
    EMAIL: "Field",
    PHONE: "Field",
    RADIO: "Radio",
    RADIOBUTTONS: "RadioButtons",
    CHECK: "Check",
    UPLOAD: "Upload",
    SCHOOL: "School",
    DROPDOWN: "Dropdown",
    MULTISELECT: "MultiSelect"
  },
  TEXT: {
    PAGEHEADING: "PageHeading",
    FIELDSETHEADING: "FieldsetHeading",
    FIELDHEADING: "FieldHeading",
    FIELDDATEHEADING: "FieldDateHeading",
    PARAGRAPH: "Paragraph",
    LIST: "List",
    TAG: "Tag",
    ALERT: "Alert",
    SUBMITTED: "Submitted",
    AUTHORISE: "Authorised",
    GRID: "Grid",
    BANNER: "Banner",
    SCHOOL: "School",
    THREEPOINTS: "ThreePoints"
  },
  FORM: {
    ACTIONS: "FormActions",
    DIVIDER: "FormDivider",
    BUTTON: "Button"
  }
};
